module.exports = __webpack_public_path__ + "img/part9-6.3cc8d770.png";